import { Flex, Tag, FloraTypography } from '@grupoboticario/flora-react';
import { ExclamationMarkTriangleOutlineIcon } from '@grupoboticario/flora-react-icons';

import { isMobile } from 'core/use-cases/app/helpers';
import { ProductCard } from 'ui/components';
import { getValueTag } from 'ui/containers/ContentBuilder/widgets/utilities/tag';
import type { ConsumerPrice, ResellerPrice } from 'ui/components';

type TProductListPrices = {
  resellerPrice: ResellerPrice;
  consumerPrice: ConsumerPrice;
  isResellerOnly: boolean;
};

const ProductListPrices = ({
  resellerPrice,
  consumerPrice,
  isResellerOnly,
}: TProductListPrices) => {
  const isMobileFlag = isMobile();
  const discount = getValueTag(resellerPrice, consumerPrice);
  const hasPromotion = discount > 0;

  return (
    <ProductCard.ListPricesWrapper>
      <ProductCard.PriceWrapper>
        <ProductCard.PriceTitle>Pague</ProductCard.PriceTitle>
        {isMobileFlag ? (
          <ProductCard.PriceValueMobile data-max>
            {hasPromotion && (
              <ProductCard.OldValueMobile
                tabIndex={0}
                aria-label={`de ${consumerPrice.maxPrice}`}
                data-testid="old-price"
              >
                {consumerPrice.maxPrice}
              </ProductCard.OldValueMobile>
            )}
            <span
              tabIndex={0}
              aria-label={`${hasPromotion ? 'por' : 'pague'} ${resellerPrice.price}`}
            >
              {resellerPrice.price}
            </span>
          </ProductCard.PriceValueMobile>
        ) : (
          <ProductCard.PriceValue data-max>
            {hasPromotion && (
              <ProductCard.OldValue
                tabIndex={0}
                aria-label={`de ${consumerPrice.maxPrice}`}
                data-testid="old-price"
              >
                {consumerPrice.maxPrice}
              </ProductCard.OldValue>
            )}
            <span
              tabIndex={0}
              aria-label={`${hasPromotion ? 'por' : 'pague'} ${resellerPrice.price}`}
            >
              {resellerPrice.price}
            </span>
          </ProductCard.PriceValue>
        )}
      </ProductCard.PriceWrapper>

      {isResellerOnly && (
        <ProductCard.BlockedToSellTag variant="disabled" shape="ghost">
          <Flex gap="$1" align="center">
            <ExclamationMarkTriangleOutlineIcon size={16} />
            <FloraTypography fontSize="exceptionsAuxiliar">Revenda proibida</FloraTypography>
          </Flex>
        </ProductCard.BlockedToSellTag>
      )}

      {!isResellerOnly && (
        <>
          <ProductCard.PriceWrapper>
            <ProductCard.PriceTitle>Revenda</ProductCard.PriceTitle>
            <ProductCard.PriceValue tabIndex={0} aria-label={`revenda por ${consumerPrice.price}`}>
              {consumerPrice.price}
            </ProductCard.PriceValue>
          </ProductCard.PriceWrapper>
          <ProductCard.PriceWrapper>
            <ProductCard.PriceTitle>Lucre</ProductCard.PriceTitle>
            <ProductCard.PriceValue tabIndex={0} aria-label={`lucre ${resellerPrice.profit}`}>
              {resellerPrice.profit}
            </ProductCard.PriceValue>
          </ProductCard.PriceWrapper>
        </>
      )}
    </ProductCard.ListPricesWrapper>
  );
};

export default ProductListPrices;
